document.addEventListener('DOMContentLoaded', function () {
  const fileFieldContainer = document.querySelectorAll('.file-field');

  if (fileFieldContainer.length) {
    for (const container of fileFieldContainer) {
      const fileInput = container.querySelector('input[type="file"]');
      const labelContainer = container.querySelector('label');

      addFileFieldChangeEvent(fileInput, container);
      addFileFieldDragAndDropEvent(fileInput, labelContainer);
    }
  }
});

function addFileFieldChangeEvent(input, container) {
  const title = container.querySelector('.file-field-title');
  const subtitle = container.querySelector('.file-field-subtitle');
  const label = container.querySelector('label');
  const image = container.querySelector('.file-field-image');

  if (title && !!title.querySelector('a')) {
    const fileName = title.querySelector('span.line-clamp-2');
    fileName.innerText = handleFileNameLength(fileName.innerText);
  }

  input.addEventListener('change', () => {
    const file = input.files[0];

    if (!file) {
      return;
    }

    if (!applyFileFieldValidation(input, container, file)) {
      return;
    }

    if (title) {
      const fileName = title.querySelector('span.line-clamp-2');
      fileName.innerText = handleFileNameLength(file.name);
      const seeFileLink = title.querySelector('a');
      title.removeChild(seeFileLink);
    }

    if (subtitle) {
      subtitle.innerText = '';
    }

    if (label) {
      label.classList.remove('border-danger', 'border-light-primary', 'border-pending', 'border-success');
      label.classList.add('border-primary');
    }

    if (image) {
      image.src = image.dataset.defaultImage;
    }
  });
}

function addFileFieldDragAndDropEvent(input, labelContainer) {
  labelContainer.addEventListener('dragenter', (ev) => ev.preventDefault());
  labelContainer.addEventListener('dragover', (ev) => ev.preventDefault());
  labelContainer.addEventListener('drop', (ev) => {
    input.files = ev.dataTransfer.files;

    ev.preventDefault();
    input.dispatchEvent(new Event('change'));
  })
}

function applyFileFieldValidation(input, container, file) {
  const errorContainer = container.querySelector('.file-field-error');
  const message = fileFieldValidationMessage(input, file);

  if (!message) {
    if (errorContainer) {
      errorContainer.classList.add('d-none');
    }
    return true;
  }

  input.value = '';
  resetFileFieldDisplay(container);

  const label = container.querySelector('label');
  if (label) {
    label.classList.remove('border-primary', 'border-light-primary', 'border-pending', 'border-success');
    label.classList.add('border-danger');
  }

  if (errorContainer) {
    errorContainer.innerText = message;
    errorContainer.classList.remove('d-none');
  }

  return false;
}

function resetFileFieldDisplay(container) {
  const title = container.querySelector('.file-field-title');
  const subtitle = container.querySelector('.file-field-subtitle');
  const image = container.querySelector('.file-field-image');

  if (title) {
    const fileName = title.querySelector('span.line-clamp-2');
    fileName.innerText = title.dataset.title;
  }

  if (subtitle) {
    subtitle.innerText = subtitle.dataset.subtitle;
  }

  if (image) {
    image.src = image.dataset.defaultImage;
  }
}

function fileFieldValidationMessage(input, file) {
  const {
    validationExtensions,
    validationMinSize,
    validationMaxSize,
    validationErrorExtension,
    validationErrorTooSmall,
    validationErrorTooLarge,
  } = input.dataset;

  if (!validationExtensions) {
    return null;
  }

  const extension = file.name.split('.').pop().toLowerCase();

  if (!validationExtensions.split(',').includes(extension)) {
    return validationErrorExtension;
  }

  if (validationMinSize && file.size < Number(validationMinSize)) {
    return validationErrorTooSmall;
  }

  if (validationMaxSize && file.size > Number(validationMaxSize)) {
    return validationErrorTooLarge;
  }

  return null;
}

function handleFileNameLength(name) {
  return name.length > 30 ? `${name.substring(0, 15)}...${name.substring(name.length - 15)}` : name;
}

window.addFileFieldChangeEvent = addFileFieldChangeEvent;
window.addFileFieldDragAndDropEvent = addFileFieldDragAndDropEvent;
